<ng-container>
  
  <p>Gerenciamento de corretores</p>

  <div>
    <div *ngIf="loading" class="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="receivedLead" matSortDirection="desc" matSortDisableClear="true" (matSortChange)="sortTable($event)" [summary]="'Distribuição de leads por corretor'">
    
      <ng-container matColumnDef="agentName">
        <th mat-header-cell *matHeaderCellDef id="agentName"> Corretor </th>
        <td mat-cell *matCellDef="let element">
          {{element.agent_name}}
        </td>
      </ng-container>
    
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef id="status"> Status </th>
        <td mat-cell *matCellDef="let element"  [ngStyle]="{'color': element.status === 'Online' ? 'green':'red'}" class="status-cell">
          {{element.status}}
        </td>
      </ng-container>

      <ng-container matColumnDef="receivedLead">
        <th mat-header-cell *matHeaderCellDef mat-sort-header id="receivedLead"> Leads recebidos </th>
        <td mat-cell *matCellDef="let element">
          {{element.received_lead_amount}}
        </td>
      </ng-container>
    
      <ng-container matColumnDef="queueName">
        <th mat-header-cell *matHeaderCellDef id="queueName"> Fila </th>
        <td mat-cell *matCellDef="let element">
          {{element.queue_name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastLogin">
        <th mat-header-cell *matHeaderCellDef id="lastLogin"> Último Login </th>
        <td mat-cell *matCellDef="let element">
          {{element.last_login | date:'dd/MM/yy HH:mm': 'UTC +0'}}
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    
    <mat-paginator class="custom-paginator" #paginator [pageIndex]="0" [pageSizeOptions]="[5, 10, 20]" [length]="total" [pageSize]="maxResults" (page)="pageChange($event)">
    </mat-paginator>
  </div>

</ng-container>